import type { HTMLProps } from 'react';
import React from 'react';

import { DEFAULT_ARIA_INDEX_OFFSET } from '../../Datagrid.consts';

import styles from './DatagridCell.module.scss';

type DatagridCellBaseProps = { hide?: boolean; index: number; rowIndex: number };

export type DatagridCellProps = DatagridCellBaseProps & HTMLProps<HTMLDivElement>;

export const DatagridCell: React.FC<DatagridCellProps> = ({ children, hide, index, rowIndex }) => {
	const getCellIndex = (rowIdx: number, idx: number) =>
		(rowIdx + DEFAULT_ARIA_INDEX_OFFSET) * (idx + DEFAULT_ARIA_INDEX_OFFSET);

	if (hide) return null;

	return (
		<div
			aria-colindex={getCellIndex(rowIndex, index)}
			aria-colspan={index + DEFAULT_ARIA_INDEX_OFFSET}
			className={styles.datagridCell}
			role="cell"
		>
			{children}
		</div>
	);
};
